export default theme => ({
  blockContainer: {
    position: 'relative',
    height: '100%',
    width: '100vw',
    minWidth: 1400,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      height: 'initial',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
      backgroundImage: 'none !important',
      backgroundColor: theme.palette.orange.main,
    },
  },
  content: {
    position: 'absolute',
    width: '65vw',
    left: '63%',
    top: 'calc(50% - 28px)',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      left: 'initial',
      top: 'initial',
      transform: 'none',
      width: '100%',
    },
  },
  articles: {
    position: 'absolute',
    width: '20%',
    top: '55%',
    left: '5%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    transform: 'translateY(-50%)',
    backgroundColor: theme.palette.white.main,
    color: theme.palette.blue.dark,
    padding: '20px 0',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      top: 'initial',
      left: 'initial',
      width: 'initial',
      height: 'initial',
      margin: `0 auto`,
      transform: 'none',
      backgroundColor: theme.palette.orange.main,
      padding: theme.spacing(2),
    },
  },
  article: {
    padding: theme.spacing(6),
    maxWidth: '100%',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2, 6),
      backgroundColor: theme.palette.white.main,
      maxWidth: 'initial',
    },
  },
});
